import React from "react";

const Services = () => {
  return (
    <>
      <section className="serviceSec sectionPD">
        <div className="container">
          <div className="fisherman-content">
            <h6>GGAS</h6>
            <h3>Our Services</h3>
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;
